module.exports = __webpack_public_path__ + "static/media/desk_bg.5322fc12.png";